import * as sliders from './rk-sliders'

const initializeKitchenColourSchemeImagePosition = () => {
  const scope = document.querySelector('.colours-features .kitchen-colour-schemes')

  if (!scope) {
    return
  }

  const imageContainer = scope.querySelector('.image-container')
  const colourSchemes = scope.querySelectorAll('.colour-scheme-1, .colour-scheme-2')

  if (!imageContainer) {
    return
  }

  const syncHorizontalPosition = () => {
    let hasOverflowingImage = false

    colourSchemes.forEach(colourScheme => {
      const image = colourScheme.querySelector('img')

      if (!image) {
        return
      }

      const imageWidth = Math.max(image.scrollWidth, image.offsetWidth)
      const containerWidth = colourScheme.clientWidth

      if (imageWidth > containerWidth) {
        hasOverflowingImage = true
        image.style.objectPosition = '50% 50%'
      } else {
        image.style.objectPosition = ''
      }
    })

    const maxScroll = Math.max(0, imageContainer.scrollWidth - imageContainer.clientWidth)
    imageContainer.scrollLeft = hasOverflowingImage ? maxScroll : 0
  }

  requestAnimationFrame(syncHorizontalPosition)
  window.addEventListener('resize', syncHorizontalPosition)

  colourSchemes.forEach(colourScheme => {
    const image = colourScheme.querySelector('img')

    if (image && !image.complete) {
      image.addEventListener('load', syncHorizontalPosition, { once: true })
    }
  })
}

const initializeKitchenColourSchemes = () => {
  const colourSchemes = document.querySelector('.colours-features .kitchen-colour-schemes')
  const buttons = colourSchemes.querySelectorAll('.colour-scheme-toggle .colour-scheme-button')

  // When a button is clicked, give it the 'active' class, remove the 'active' class from the other button, and add the '.toggle-2nd' class to the .image-container element
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetScheme = button.getAttribute('data-scheme')
      const imageContainer = colourSchemes.querySelector('.image-container')

      buttons.forEach((btn) => {
        if (btn === button) {
          btn.classList.add('active')
        } else {
          btn.classList.remove('active')
        }
      })

      if (targetScheme === '2') {
        imageContainer.classList.add('toggle-2nd')
      } else {
        imageContainer.classList.remove('toggle-2nd')
      }
    })
  })
}

const initializeBathroomColourSchemes = () => {
  const colourSchemes = document.querySelector('.colours-features .bathroom-colour-schemes')
  const buttons = colourSchemes.querySelectorAll('.colour-scheme-toggle .colour-scheme-button')

  // When a button is clicked, give it the 'active' class, remove the 'active' class from the other button, and add the '.toggle-2nd' class to the .image-container element
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetScheme = button.getAttribute('data-scheme')
      const imageContainer = colourSchemes.querySelector('.image-container')

      buttons.forEach((btn) => {
        if (btn === button) {
          btn.classList.add('active')
        } else {
          btn.classList.remove('active')
        }
      })

      if (targetScheme === '2') {
        imageContainer.classList.add('toggle-2nd')
      } else {
        imageContainer.classList.remove('toggle-2nd')
      }
    })
  })
}

export const initializeHomes = () => {
  const exteriorsGallerySlider = document.querySelector('.exteriors-gallery .swiper')
  const interiorsGallerySlider = document.querySelector('.interiors-gallery .swiper')
      
  sliders.initializeSlider(exteriorsGallerySlider)
  sliders.initializeSlider(interiorsGallerySlider)

  initializeKitchenColourSchemeImagePosition()
  
  initializeKitchenColourSchemes()
  initializeBathroomColourSchemes()
}